// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'wrap';

export const Component = () => (
  <g fill='none' stroke='currentColor'>
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M3 7.25h5m-5 2.5V5.337c0-.686.263-1.344.732-1.83A2.458 2.458 0 0 1 5.5 2.75a2.46 2.46 0 0 1 1.768.758A2.63 2.63 0 0 1 8 5.337V9.75'
    />
    <path d='M12.672 13.72H5.5m7.172-5H10m2.656 5a2.5 2.5 0 1 0 0-5m-7.302 4.856 1.767 1.768m-1.975-1.268 1.98-1.98' />
  </g>
);

export const viewBox = '0 0 18 18';
